import { EditorThemeClasses } from "lexical";

import css from "./theme.module.scss";

//This file is mapping css classes to the editor.
// For more info: https://lexical.dev/docs/getting-started/theming

export const theme: EditorThemeClasses = {
	ltr: css.ltr,
	rtl: css.rtl,
	characterLimit: css.editorCharacterLimit,
	placeholder: css.editorPlaceholder,
	paragraph: css.editorParagraph,
	quote: css.editorQuote,
	heading: {
		h1: css.editorHeadingH1,
		h2: css.editorHeadingH2,
	},
	list: {
		nested: {
			listitem: css.editorNestedListitem,
		},
		ol: css.editorListOl,
		ul: css.editorListUl,
		listitem: css.editorListitem,
	},
	image: css.editorImage,
	link: css.editorLink,
	text: {
		bold: css.editorTextBold,
		italic: css.editorTextItalic,
		underline: css.editorTextUnderline,
		strikethrough: css.editorTextStrikethrough,
		underlineStrikethrough: css.editorTextUnderlineStrikethrough,
	},
	root: "root",
};
